import React from 'react';
import { Switch, Collapse } from 'antd';
import { Helmet } from 'react-helmet';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { get } from 'lodash';

import FundkyModal from 'Parts/ui/components/FundkyModal';
import FakeField from 'Parts/ui/components/fields/FakeField';
import TaxReceiptCampaignSettingsActivationModalContent from './TaxReceiptCampaignSettingsActivationModalContent';

import TaxReceiptCampaignSettingsPanel_en from './locales/TaxReceiptCampaignSettingsPanel_en.json';
import TaxReceiptCampaignSettingsPanel_fr from './locales/TaxReceiptCampaignSettingsPanel_fr.json';

import './TaxReceiptCampaignSettingsPanel.less';

class TaxReceiptCampaignSettingsPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      switchActivated: false,
      confirmDisabled: true,
      switchActivated2: false,
      confirmDisabled2: true
    };

    props.fetchEvent(props.campaign.id, true, {showLocation: true, showSettings: true})
      .then(reponse => {
        this.setState({
          switchActivated2: (get(reponse, 'payload.settings.taxReceipt.enabled', false) == true)? true:false
        });
      });
    props.fetchTaxReceiptPlatformIssuingEnabled(props.state.platform.platform.id);
    props.fetchTaxReceiptCampaignIssuingEnabled(props.campaign.id).then(status => {
      this.setState({
        switchActivated: status.payload.enabled
      });
    });

    this.modalRef = React.createRef();
    this.modalRef2 = React.createRef();

    i18next.addResourceBundle(
      'en',
      'TaxReceiptCampaignSettingsPanel',
      TaxReceiptCampaignSettingsPanel_en
    );
    i18next.addResourceBundle(
      'fr',
      'TaxReceiptCampaignSettingsPanel',
      TaxReceiptCampaignSettingsPanel_fr
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) this.props.form.resetFields();
  }

  handleActivation = value => {
    this.setState(
      {
        switchActivated: value
      },
      () => {
        this.handleShowModal();
      }
    );
  };

  switchBack = value => {
    this.setState({
      switchActivated: !value
    });
  };

  handleShowModal = () => {
    this.modalRef.current.getWrappedInstance('FundkyModal').showModal();
  };

  handleHideModal = () => {
    this.modalRef.current.getWrappedInstance('FundkyModal').hideModal();
    this.disableConfirm();
  };

  handleModalConfirm = () => {
    const value = this.state.switchActivated ? 1 : 2;
    const campaignId = this.props.campaign.id;
    this.props.updateTaxReceiptCampaignIssuingStatus(campaignId, value);
    this.handleHideModal();
  };

  handleModalCancel = () => {
    this.disableConfirm();
    this.switchBack(this.state.switchActivated);
  };

  disableConfirm = () => {
    this.props.form.resetFields();
    this.setState({
      confirmDisabled: true
    });
  };

  handleConfirmInput = event => {
    const { props, state } = this,
      { t } = props,
      { confirmDisabled } = state,
      answer = t('answer'),
      value = event.currentTarget.value.toUpperCase();

    if (answer === value) {
      if (confirmDisabled) {
        this.setState({ confirmDisabled: !confirmDisabled });
      }
    } else {
      if (!confirmDisabled) {
        this.setState({ confirmDisabled: !confirmDisabled });
      }
    }
  };

/*** */
  handleActivation2 = value => {
    this.setState(
      {
        switchActivated2: value
      },
      () => {
        this.handleShowModal2();
      }
    );
  };

  switchBack2 = value => {
    this.setState({
      switchActivated2: !value
    });
  };

  handleShowModal2 = () => {
    this.modalRef2.current.getWrappedInstance('FundkyModal').showModal();
  };

  handleHideModal2 = () => {
    this.modalRef2.current.getWrappedInstance('FundkyModal').hideModal();
    this.disableConfirm2();
  };

  handleModalConfirm2 = () => {
    const value = this.state.switchActivated2 ? true : false;
    const campaignId = this.props.campaign.id;
    this.props.updateEventSettings(campaignId, {taxReceipt: value});
    this.handleHideModal2();
  };

  handleModalCancel2 = () => {
    this.disableConfirm2();
    this.switchBack2(this.state.switchActivated2);
  };

  disableConfirm2 = () => {
    this.props.form.resetFields();
    this.setState({
      confirmDisabled2: true
    });
  };

  handleConfirmInput2 = event => {
    const { props, state } = this,
      { t } = props,
      { confirmDisabled2 } = state,
      answer = t('answer'),
      value = event.currentTarget.value.toUpperCase();

    if (answer === value) {
      if (confirmDisabled2) {
        this.setState({ confirmDisabled2: !confirmDisabled2 });
      }
    } else {
      if (!confirmDisabled2) {
        this.setState({ confirmDisabled2: !confirmDisabled2 });
      }
    }
  };

  render() {
    const {
        props,
        state,
        modalRef,
        handleActivation,
        handleModalConfirm,
        handleModalCancel,
        handleConfirmInput,
        modalRef2,
        handleActivation2,
        handleModalConfirm2,
        handleModalCancel2,
        handleConfirmInput2
      } = this,
      { t, form, campaign, isUpdateConfigurationInProgress, plaformIssuingEnabled } = props,
      { switchActivated, confirmDisabled, switchActivated2, confirmDisabled2 } = state,
      { Panel } = Collapse;

    const switchDisabled = !plaformIssuingEnabled;
    const isCampaignInactive = campaign && (campaign.statusId === 5 || campaign.statusId === 3);

    return (
      <div className="TaxReceiptCampaignSettingsPanel ant-form-horizontal ant-form-horizontal">
        <Helmet>
          <title>{t('page-title')}</title>
        </Helmet>
        <Collapse accordion bordered={false} defaultActiveKey={['1']}>
          <Panel header={t('title-regular')} key="1">
            <FakeField
              className="TaxReceiptCampaignSettingsPanel__ActivateField"
              label={t('issue-label-regular')}
              data={
                <React.Fragment>
                  <Switch
                    className="TaxReceiptCampaignSettingsPanel__ActivateField--switch"
                    checked={switchActivated}
                    disabled={switchDisabled}
                    checkedChildren={t('activated')}
                    unCheckedChildren={t('deactivated')}
                    loading={isUpdateConfigurationInProgress}
                    onClick={handleActivation}
                    disabled={isCampaignInactive}
                  />
                  {switchActivated ? (
                    <span className="TaxReceiptCampaignSettingsPanel--active">
                      {t('issue-activated-notice-regular')}
                    </span>
                  ) : (
                    <span className="TaxReceiptCampaignSettingsPanel--inactive">
                      {t('issue-deactivated-notice-regular')}
                    </span>
                  )}
                </React.Fragment>
              }
            />
            <p>{t('issue-notice-regular')}</p>
          </Panel>
        </Collapse>
        {campaign.behavior === "EVENT" &&
        <Collapse accordion bordered={false} defaultActiveKey={['2']}>
          <Panel header={t('title-ticket')} key="2">
            <FakeField
              className="TaxReceiptCampaignSettingsPanel__ActivateField"
              label={t('issue-label-ticket')}
              data={
                <React.Fragment>
                  <Switch
                    className="TaxReceiptCampaignSettingsPanel__ActivateField--switch"
                    checked={switchActivated2}
                    disabled={switchDisabled}
                    checkedChildren={t('activated')}
                    unCheckedChildren={t('deactivated')}
                    loading={isUpdateConfigurationInProgress}
                    onClick={handleActivation2}
                    disabled={isCampaignInactive}
                  />
                  {switchActivated2 ? (
                    <span className="TaxReceiptCampaignSettingsPanel--active">
                      {t('issue-activated-notice-ticket')}
                    </span>
                  ) : (
                    <span className="TaxReceiptCampaignSettingsPanel--inactive">
                      {t('issue-deactivated-notice-ticket')}
                    </span>
                  )}
                </React.Fragment>
              }
            />
            <p>{t('issue-notice-ticket')}</p>
          </Panel>
        </Collapse>
        || null}
        <FundkyModal
          ref={modalRef}
          acceptAction={handleModalConfirm}
          cancelAction={handleModalCancel}
          title={switchActivated ? t('modal-title-activation') : t('modal-title-deactivation')}
          acceptDisabled={confirmDisabled}
          isAcceptInProgress={isUpdateConfigurationInProgress}
        >
          <TaxReceiptCampaignSettingsActivationModalContent
            form={form}
            switchActivated={switchActivated}
            handleConfirmInput={handleConfirmInput}
          />
        </FundkyModal>

        <FundkyModal
          ref={modalRef2}
          acceptAction={handleModalConfirm2}
          cancelAction={handleModalCancel2}
          title={switchActivated2 ? t('modal-title-activation') : t('modal-title-deactivation')}
          acceptDisabled={confirmDisabled2}
          isAcceptInProgress={isUpdateConfigurationInProgress}
        >
          <TaxReceiptCampaignSettingsActivationModalContent
            form={form}
            switchActivated={switchActivated2}
            handleConfirmInput={handleConfirmInput2}
            ticket
          />
        </FundkyModal>
      </div>
    );
  }
}

export default translate('TaxReceiptCampaignSettingsPanel')(TaxReceiptCampaignSettingsPanel);
